module.exports = __webpack_public_path__ + "img/card2.fe62d2ee.png";